import { createTheme } from "@mui/material/styles";

import palette from "./palette";
import typography from "./typography";
import overrides from "./overrides";

//console.log("overrides", overrides);

const theme = createTheme({
  palette,
  typography,
  overrides: overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});

export default theme;

// const theme = createMuiTheme({
//   palette,
//   typography,
//   overrides: {
//     MuiCardContent: {
//       root: {
//         "&:last-child": {
//           paddingBottom: 16,
//         },
//       },
//     },
//   },
//   zIndex: {
//     appBar: 1200,
//     drawer: 1100,
//   },
// });
